import React, { useEffect, useState } from "react";
import useAuth from "../hooks/useAuth";
import useMatricula from "../hooks/useMatricula";
import useProcesoMatricula from "../hooks/useProcesoMatricula";
import { update_paso, update_seguroEstudiante } from "../services/procesoMatricula/procesoMatricula";
import { obtenerLabelEtiqueta } from "../utils/idioma/LabelsIdioma";

const ModalAgregarSeguro = () => {
  const { listadoEtiquetas } = useAuth();
  const [etiquetas, setEtiquetas] = useState({});
  let { obtenerDatosEstudiante } = useMatricula();

  let {
    setPasoProcesoM,
    setCarritoHorario,
    setLoading,
    setErrorServices,
    setErrorCursoServices
  } = useProcesoMatricula();

  useEffect(() => {
    if (listadoEtiquetas.length > 0) {
      setEtiquetas({
        msj_seguro_agregar: obtenerLabelEtiqueta(
          "lbl_seguro_msj_seguro_agregar",
          listadoEtiquetas
        ),
        msj_agregado: obtenerLabelEtiqueta(
          "lbl_seguro_msj_agregado",
          listadoEtiquetas
        ),
        seguro_agregar_seguro: obtenerLabelEtiqueta(
          "lbl_seguro_agregar_seguro",
          listadoEtiquetas
        ),
      });
    }
  }, [listadoEtiquetas]);


  const { msj_seguro_agregar,
    msj_agregado, seguro_agregar_seguro } = etiquetas;
  const handleAgregarUpchCarrito = async () => {
    let valoresRegistrarSeguro = {
      radioSeguros: 0,
      empresaSeguro: 0,
      fechaVencimiento: "2022-10-28T14:35:04.046904",
      numeroPoliza: "",
      nombreArchivo: "",
      aceptoTerminos: false,
      bases64: "",
      tipoArchivo: "",
    };

    try {
      setLoading(true);
      let seguroEstudiante = await update_seguroEstudiante(obtenerDatosEstudiante, valoresRegistrarSeguro);
      if (seguroEstudiante.StatusCode == 200 && seguroEstudiante.Data.respuesta == 1) {
        setCarritoHorario({ ntipos: 0 });
        document.querySelector("#modalAgregarSeguro")?.click();

      } else {
        throw seguroEstudiante.Message;
      }
    } catch (error) {
      setLoading(false);
      let modalErrorr = document.querySelector("#modalErr");

      if (modalErrorr) {
        modalErrorr.click();

        setErrorCursoServices(error);
      }
    } finally {
      setLoading(false);

    }
  }
  return (
    <div
      className="modal fade"
      id="modalidad2"
      tabIndex={-1}
      aria-labelledby="exampleModalLabel1"
      aria-hidden="true"
    >
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header border-bottom-0">
            <h5 className="modal-title" id="exampleModalLabel1" />
            <button
              type="button"
              className="btn-close"
              aria-label="Close"
              data-bs-dismiss="modal"
            />
          </div>
          <div className="modal-body">
            <div className="text-center">
              <h5 className="text-uppercase ">
                {msj_seguro_agregar}
              </h5>
              <p>{msj_agregado}.</p>
            </div>
          </div>
          <div className="modal-footer">

            <button
              type="button"
              className="btn btn-primary"
              onClick={handleAgregarUpchCarrito}
            >
              {seguro_agregar_seguro}
            </button>

            <button
              style={{ display: "none" }}
              data-bs-toggle="modal"
              data-bs-target="#error"
              id="modalErr"
            ></button>
            <button
              style={{ display: "none" }}
              data-bs-toggle="modal"
              data-bs-target="#agregarSeguro"
              id="modalAgregarSeguro"
            ></button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ModalAgregarSeguro;
